<template>
  <div>
    <router-view></router-view>
    <!--<error-modal :dialog="dialog" :error="dialogData" @close="dialog = false"></error-modal>-->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import store from './store/index'
import router from './router'
import ApiBase from '@/api/apiBase'
import Bus from '@/components/bus'


export default {
  name: 'app',
  data(){
    return {
      dialog: false,
      dialogData: {
        code: 500,
        title: 'Server Error',
        message: 'Error'
      }
    }
  },
  created() {
    /*do something after creating vue instance
    Bus.$on(Bus.ACTION_SHOW_ALERT, event => {
      this.showDialog(event.title, event.msg)
    })
    Bus.$on(Bus.ACTION_LOG_OUT, event => {
      //this.logOut()
    })*/
  },
  props: {
    source: String
  },
  methods: {
    ...mapActions([
      'logOut'
    ]),
    showDialog(title, msg){
      this.dialogData.title = title
      this.dialogData.message = msg
      this.dialog = true
    }
  }
}
</script>

<style lang="scss">
  @import 'src/assets/scss/main';
</style>



// WEBPACK FOOTER //
// src/App.vue